module.exports = __webpack_public_path__ + "bdd09c0974835f625f44220f48065501.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/ian-cheng1.gif
 ** module id = 382
 ** module chunks = 0
 **/